__webpack_require__.p = "https://ca-cp-fe.sandbox.securitize.io/";